import { jsx as _jsx } from "react/jsx-runtime";
import { Calendar } from "@air/next-icons";
import { MONTH_DAY_YEAR_FORMAT, parseAirDateToISO } from "@air/utilities";
import { format } from "__barrel_optimize__?names=format!=!date-fns";
import { memo } from "react";
import { useSelector } from "react-redux";
import { InfoPanelDetailsSection } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection";
import { InfoPanelDetailValue } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailValue";
import { centralizedClipRecordedAtSelector } from "~/store/centralizedClip/selectors";
export const InfoPanelDateCreated = /*#__PURE__*/ memo(()=>{
    const recordedAt = useSelector(centralizedClipRecordedAtSelector);
    const formattedCreatedAt = format(parseAirDateToISO(recordedAt), MONTH_DAY_YEAR_FORMAT);
    if (!formattedCreatedAt) {
        return null;
    }
    return /*#__PURE__*/ _jsx(InfoPanelDetailsSection, {
        Icon: Calendar,
        title: "Date Created",
        children: /*#__PURE__*/ _jsx(InfoPanelDetailValue, {
            value: formattedCreatedAt
        })
    });
});
InfoPanelDateCreated.displayName = "InfoPanelDateCreated";
